import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import AppBar from '@material-ui/core/AppBar';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Toolbar from '@material-ui/core/Toolbar';
import AddIcon from '@material-ui/icons/Add'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import CloseIcon from '@material-ui/icons/Close'
import CachedIcon from '@material-ui/icons/Cached';
import ListIcon from '@material-ui/icons/List';
import { connect } from "react-redux"
import store from '../../Redux/store'
import { loadData, upsertVisitAction } from '../../Redux/actions'
import VisitForm from '../../Components/VisitForm'
import moment from 'moment'
import MenuIcon from '@material-ui/icons/Menu'
import StatusIndicator from '../../Components/StatusIndicator';
import QueueList from '../../Components/QueueList';
import OdooApi from '../../Api/odoo_api';
import uuid from 'react-uuid'
import { Button, Snackbar } from '@material-ui/core';

const drawerWidth = 240;

const styles = theme => ({
    root: {
        width: '100%',
        // maxWidth: '36ch',
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: 'inline',
    },
    line: {
        cursor: 'pointer'
    },
    addVisitButton: {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        color: 'white'
    },
    title: {
        flex: 1
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    drawerPaper: {
        width: drawerWidth,
    },
});

class HomePage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            is_visit_form_open: false,
            is_mobile_drawer_open: false,
            is_queue_list_open: false,
            show_reload_page: false,
            show_install_page: false,
        }

        window.addEventListener('service-worker-state-changed', e => {
            console.log(e.detail.state);
            if (e.detail.state === 'activated') {
                this.setState({
                    show_reload_page: true
                })
            }
        });

        // let deferredPrompt;

        window.addEventListener('beforeinstallprompt', (e) => {
            console.log('beforeinstallprompt');
            const deferredPrompt = e;

            this.setState({
                show_install_page: true,
                deferredPrompt
            })
            
            // deferredPrompt.prompt('Meteleeeee').then(r => console.log(r))
            
            // e.prompt('Meteleeeee').then(r => console.log(r))
            // Prevent the mini-infobar from appearing on mobile
            // e.preventDefault();
            // // Stash the event so it can be triggered later.
            // deferredPrompt = e;
            // // Update UI notify the user they can install the PWA
            // showInstallPromotion();
            // // Optionally, send analytics event that PWA install promo was shown.
            // console.log(`'beforeinstallprompt' event was fired.`);
        });
    }

    handleListItemClick = (visit, recipient) => {
        // store.dispatch(updateGlobalState({
        //     currentVisit: visit,
        //     is_visit_form_open: true,
        //     // activePageComponent: 'visit',
        //     currentRecipient: recipient
        // }))
        this.setState({
            is_visit_form_open: true,
            currentVisit: {
                ...visit,
                // 'date_start': moment(visit.simple_date).format('YYYY-MM-DD'), 
                // 'time_start': moment(visit.simple_date + ' ' + visit.sb_in).format('HH:mm'), 
                // 'date_end': moment(visit.out_date).format('YYYY-MM-DD'), 
                // 'time_end': moment(visit.out_date + ' ' + visit.out).format('HH:mm'),
                // 'recipient_id': visit.recipient_id
            }
        })
    }

    handleAddVisitButtonClick = async e => {
        if (window.location.hostname !== 'localhost') {
            try {
                const response = await OdooApi.get_new_service_log_url()
                window.location = response.url
                return
            }
            catch (e) {

            }
        }

        const now = moment()
        this.setState({
            is_visit_form_open: true,
            currentVisit: {
                'date_start': now.format('YYYY-MM-DD'),
                'time_start': now.format('HH:mm'),
                'date_end': now.format('YYYY-MM-DD'),
                'time_end': now.add(30, 'minutes').format('HH:mm'),
                'units': 2,
                'bam_id': uuid(),
                'visit_state': 'New'
            },
        })
    }

    handleVisitFormClose = e => {
        this.setState({
            is_visit_form_open: false
        })
    }

    handleQueueListClose = e => {
        this.setState({
            is_queue_list_open: false
        })
    }

    handleDrawerToggle = e => {
        this.setState({
            is_mobile_drawer_open: !this.state.is_mobile_drawer_open
        })
    }

    handleVisitFormSave = data => {
        // if (data.state !== 'submitted' || data.state !== this.state.currentVisit.state) {
        //     if (data.id) {
        //         store.dispatch(updateVisitAction(data))
        //     }
        //     else {
        //         store.dispatch(addVisitAction(data))
        //     }
        // }

        store.dispatch(upsertVisitAction(data))

        if (data.visit_state === 'Cancelled') {
            this.setState({
                is_visit_form_open: false
            })
        }
    }

    handleReloadClick = e => {
        store.dispatch(loadData(false))
        this.setState({
            is_mobile_drawer_open: false
        })
    }

    handleClearQueueClick = e => {
        localStorage.setItem('sync_queue', JSON.stringify({
            lastUpdate: Date.now(),
            queue: []
        }))
        this.setState({
            is_mobile_drawer_open: false
        })
    }

    handleOpenQueueClick = e => {
        this.setState({
            is_queue_list_open: true,
            is_mobile_drawer_open: false
        })
    }

    render() {
        const { classes } = this.props;

        const items = []
        const sorted_visits = Object.entries(this.props.visits).sort((first, second) => {
            const first_moment = moment(first[1][0].date_start + ' ' + first[1][0].time_start)
            const second_moment = moment(second[1][0].date_start + ' ' + second[1][0].time_start)
            if (first_moment > second_moment) {
                return 1
            }
            if (first_moment < second_moment) {
                return -1
            }
            return 0
        })

        // for (let index = 0; index < this.props.visits.length; index++) {
        for (let index of sorted_visits) {
            const visit = index[1][0]
            if (visit.visit_state === 'Cancelled')
                continue
            // [].find()
            // const recipient = this.props.recipients.find(x => x['id'] === visit['client_id'][0])
            if (!this.props.recipients[visit.recipient_id])
                continue
            const recipient = this.props.recipients[visit.recipient_id][0]
            items.push(
                <ListItem className={classes.line} alignItems="flex-start" key={'item-' + visit['id']} onClick={() => this.handleListItemClick(visit, recipient)}>
                    <ListItemAvatar>
                        <Avatar alt={recipient.name} src={'data:image/png;base64,' + (recipient ? recipient.image_small : '')} />
                    </ListItemAvatar>
                    <ListItemText
                        primary={
                            <React.Fragment>
                                <b>{recipient.name}</b>: <b>{visit.date_start}</b>
                            </React.Fragment>
                        }
                        secondary={
                            <React.Fragment>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    className={classes.inline}
                                    color="textPrimary"
                                >
                                    <b>{visit.time_start}</b>: {visit.service_address1}
                                </Typography>
                                <br />
                                <Typography
                                    component="span"
                                    variant="body2"
                                    className={classes.inline}
                                    color="textPrimary"
                                >
                                    <b>{visit.time_end}</b>: {visit.end_address_1}
                                </Typography>
                                <br />
                                {visit.note_session_details_ids && visit.note_session_details_ids.length ? '*' : ''}
                                {/* {" — " + visit['out_date']} */}
                            </React.Fragment>
                        }
                    />
                </ListItem>
            )

            items.push(
                <Divider variant="inset" component="li" key={'divider-' + visit['id']} />
            )
        }

        return (
            <React.Fragment>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.show_reload_page}
                    autoHideDuration={6000}
                    onClose={e => {this.setState({show_reload_page: false})}}
                    message="New version available!"
                    action={
                        <React.Fragment>
                            <Button color="secondary" size="small" onClick={e => {window.location.reload()}}>
                                RELOAD
                            </Button>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={e => {this.setState({show_reload_page: false})}}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.show_install_page}
                    autoHideDuration={6000}
                    onClose={e => {this.setState({show_install_page: false})}}
                    message="Add to yor home screen!"
                    action={
                        <React.Fragment>
                            <Button color="secondary" size="small" onClick={e => {
                                    this.state.deferredPrompt.prompt('Accept the next prompt')
                                        .then(r => {
                                            console.log(r)
                                        })
                                        
                                        this.setState({show_install_page: false})
                                    }
                                }>
                                INSTALL
                            </Button>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={e => {this.setState({show_install_page: false})}}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />



                <AppBar position="static">
                    <Toolbar>
                        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={this.handleDrawerToggle}>
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Visits
                        </Typography>
                        <StatusIndicator />
                    </Toolbar>
                </AppBar>
                <nav className={classes.drawer} aria-label="mailbox folders">
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={this.state.is_mobile_drawer_open}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <div className={classes.drawerHeader}>
                            <IconButton onClick={this.handleDrawerToggle}>
                                <ChevronLeftIcon />
                            </IconButton>
                        </div>
                        <Divider />
                        <List>
                            <ListItem button onClick={this.handleReloadClick}>
                                <ListItemIcon><CachedIcon /></ListItemIcon>
                                <ListItemText primary={'Reload'} />
                            </ListItem>
                            <ListItem button onClick={this.handleClearQueueClick}>
                                <ListItemIcon><CachedIcon /></ListItemIcon>
                                <ListItemText primary={'Clear Queue'} />
                            </ListItem>
                            <ListItem button onClick={this.handleOpenQueueClick}>
                                <ListItemIcon><ListIcon /></ListItemIcon>
                                <ListItemText primary={'Open Queue'} />
                            </ListItem>
                            {/* {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
                                <ListItem button key={text}>
                                    <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                                    <ListItemText primary={text} />
                                </ListItem>
                            ))} */}
                        </List>
                        <Divider />
                        {/* <List>
                            {['All mail', 'Trash', 'Spam'].map((text, index) => (
                                <ListItem button key={text}>
                                    <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                                    <ListItemText primary={text} />
                                </ListItem>
                            ))}
                        </List> */}
                    </Drawer>
                </nav>
                <List className={classes.root}>
                    {items}
                </List>
                <Fab color="primary" aria-label="add" className={classes.addVisitButton} onClick={this.handleAddVisitButtonClick}>
                    <AddIcon />
                </Fab>
                {this.state.is_visit_form_open ?
                    <VisitForm recipients={this.props.recipients}
                        handleClose={this.handleVisitFormClose}
                        handleSave={this.handleVisitFormSave}
                        data={this.state.currentVisit} />
                    : ''}
                {this.state.is_queue_list_open ?
                    <QueueList
                        handleClose={this.handleQueueListClose}
                    />
                    : ''}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        visits: state.app.global.visits,
        recipients: state.app.global.recipients,
    }
};

export default connect(mapStateToProps, null)(withStyles(styles)(HomePage));